const profile_server = "/u";
const api_server = "/api";

export const user = {
  root: profile_server,
  login: `${profile_server}/login/`,
  logout: `${profile_server}/logout/`,
  profile: `${profile_server}/profile/`,
};

export const api = {
  project: `${api_server}/p/`,
};
